import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const keys = () =>
  createEnv({
    server: {
      AUTOFINPLAN_DATABASE_URL: z.string().min(1).url()
    },
    runtimeEnv: {
      AUTOFINPLAN_DATABASE_URL: process.env.AUTOFINPLAN_DATABASE_URL
    }
  });
